import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TestService } from 'src/app/services/test.service';
import { UserService } from 'src/app/services/user.service';
import Swal from 'sweetalert2';
declare var $:any;

@Component({
  selector: 'app-requested-tests',
  templateUrl: './requested-tests.component.html',
  styleUrls: ["styles.css"]
})
export class RequestedTestsComponent implements OnInit {

  public tests = [];
  public formModel = {};
  public testData;
  public trigger = false;
  public user;
  public allTests = []
  public formModalMessage = '';

  public formWelcome = false;
  public formStarted = false;
  public formEnded = false;
  public countdown = 2400;
  public timer: any;

  constructor(private testService: TestService, private userService:UserService, private router:Router, private route: ActivatedRoute) {

  }

  ngOnInit(): void {
    let userToken = localStorage.getItem('token');
    let action = this.route.snapshot.queryParamMap.get('action');
    if (!userToken && !action){
      this.router.navigateByUrl('login');
      return
    }
    if (action == 'form'){
      return this.execute(this.testService.selectedTestData)
    }
    this.userService.getUser().subscribe(
      res=>{
        this.user = res;
        this.testService.getEvaluatedTests(res.email).subscribe(
          resp=>{
            this.tests = resp;
            this.allTests = resp;
            this.tests = this.filterTests(this.tests);
            this.tests.sort((a, b) => {
              let dateA = new Date(a.createDate);
              let dateB = new Date(b.createDate);
              return dateA > dateB ? -1 : dateA < dateB ? 1 : 0;
            })
          },
          err=>console.log(err)
        )
      },
      err=>console.log(err)
    )
  }

  ngOnDestroy(){
    if (this.testService.selectedTestData && this.testService.selectedTestData.isLocal){
      localStorage.removeItem('token')
    }
  }

  filterTests(tests){
    if (!this.havePendingTests(tests)) return tests
    let filteredTests = [];
    for (let test of tests){
      if (test.type == 'FORMULARIO'){
        filteredTests.push(test);
      }
    }
    return filteredTests;
  }

  reload(){
    location.reload()
  }

  havePendingTests(tests){
    for (let test of tests){
      if (test.type == 'FORMULARIO' && !test.isCompleted){
        return true;
      }
    }
    return false;
  }

  execute(test){

    if (!test.isCustomTest && test.isSecure){
      document.addEventListener("visibilitychange", () => {
        if (document.visibilityState === 'visible') {
          
        } else {
          if (this.testService.testStarted){
            Swal.fire({
              icon: 'warning',
              text: 'La prueba ha sido bloqueada por cambiar de pestaña o minimizar la ventana',
              confirmButtonText: 'Aceptar'
            }).then(() => {
              this.router.navigateByUrl('dashboard/requestedTests').then(() => {
                location.reload()
              });
            })
          }
        }
      });
    }

    if (!test){
      localStorage.removeItem('token')
      this.router.navigateByUrl('/login');
      return
    }
    if(test.type == "16PF"){
      this.testService.selectedTestData = test;
      this.router.navigateByUrl('dashboard/pf16');
    }

    if(test.type == "CLEAVER"){
      this.testService.selectedTestData = test;
      this.router.navigateByUrl('dashboard/cleaver');
    }

    if(test.type == "TERMAN"){
      this.testService.selectedTestData = test;
      this.router.navigateByUrl('dashboard/terman');
    }

    if(test.type == "ALL PORT"){
      this.testService.selectedTestData = test;
      this.router.navigateByUrl('dashboard/allPort');
    }

    if(test.type == "KOSTIK"){
      this.testService.selectedTestData = test;
      this.router.navigateByUrl('dashboard/kostik');
    }

    if(test.type == "IPV"){
      this.testService.selectedTestData = test;
      this.router.navigateByUrl('dashboard/ipv');
    }

    if(test.type == "ZAVIC"){
      this.testService.selectedTestData = test;
      this.router.navigateByUrl('dashboard/zavic');
    }

    if(test.type == "BARSIC"){
      this.testService.selectedTestData = test;
      this.router.navigateByUrl('dashboard/barsic');
    }

    if(test.type == "MMPI2"){
      this.testService.selectedTestData = test;
      this.router.navigateByUrl('dashboard/mmpi2');
    }

    if(test.type == "MMPIA"){
      this.testService.selectedTestData = test;
      this.router.navigateByUrl('dashboard/mmpia');
    }

    if(test.type == "MIPS"){
      this.testService.selectedTestData = test;
      this.router.navigateByUrl('dashboard/mips');
    }

    if(test.type == "BIS11"){
      this.testService.selectedTestData = test;
      this.router.navigateByUrl('dashboard/bis11');
    }

    if(test.type == "CHASIDE"){
      this.testService.selectedTestData = test;
      this.router.navigateByUrl('dashboard/chaside');
    }

    if(test.type == "DOMINO"){
      this.testService.selectedTestData = test;
      this.router.navigateByUrl('dashboard/domino');
    }

    if(test.type == "FORMULARIO"){
      this.testService.selectedTestData = test;
      this.testData = test;
      this.formWelcome = true;
      if (this.testData.camera){
        setTimeout(() => {
          this.trigger = !this.trigger;
        }, Math.floor(Math.random() * 60000 + 2000));
      }
      $('#formModal').modal('show');
    }
    if (test.isCustomTest){
      document.removeEventListener("visibilitychange", () => {});
      this.testService.selectedTestData = test;
      this.router.navigate(['/dashboard', 'custom-test', test.completeForm]) 
    }
  }

  async sendForm(){

    let response = await Swal.fire({
      icon: 'warning',
      text: '¿Está seguro de que desea enviar el formulario? Esta acción no se puede deshacer.',
      showCancelButton: true,
      confirmButtonText: 'Enviar',
      cancelButtonText: 'Cancelar'
    })

    if (!response.isConfirmed) return
    this.formStarted = false;
    let points = this.calculateFormPoints();
    this.trigger = !this.trigger;
    let obj = {
      _id:this.testService.selectedTestData._id,
      formData:this.formModel,
      isCompleted:true,
      completeDate:Date.now(),
      formScore:points,
      evaluatedName: this.testService.selectedTestData.evaluatedName,
      client: this.testService.selectedTestData.client,
      type: this.testService.selectedTestData.type,
      isCustomBrand: this.testService.selectedTestData.isCustomBrand
    }
    this.testService.updateTest(obj, false).subscribe(
      async resp=>{
        $('#formModal').modal('hide');
        this.formModalMessage = this.testData.completeForm.failMessage;
        
        if (this.testData.completeForm.aprovationScore > points && this.testData.completeForm.exclude){
          for (let test of this.allTests){
            if (!test.isCompleted && test.type != "FORMULARIO"){
              await this.testService.removeTest(test._id).toPromise()
            }
          }
        }

        $('#formMessageModal').modal('show');

        this.testService.getEvaluatedTests(this.user.email).subscribe(
          resp=>{
            this.tests = resp;
            this.tests = this.filterTests(this.tests);
          },
          err=>console.log(err)
        )
      },
      err=>console.log(err)
    );
  }

  toggleSelectedOption(question: number, option: string, multi: boolean){
    if (multi){
      if (this.formModel[question]){
        if (this.formModel[question].includes(option)){
          this.formModel[question] = this.formModel[question].filter(item => item !== option);
        }else{
          this.formModel[question].push(option);
        }
      }else{
        this.formModel[question] = [option];
      }
    }else{
      this.formModel[question] = [option];
    }

  }

  isSelected(question: number, option: string){
    if (this.formModel[question]){
      return this.formModel[question]?.includes(option);
    }
    return false;
  }

  calculateFormPoints(){
    let points = 0;
    let formData = this.testData.completeForm;
    let questionIndex = 0;
    for (let key in this.formModel){
      let formQuestion = formData.data[questionIndex];

      if (formQuestion.type == "multiple" || formQuestion.type == "radio"){
        for (let response of this.formModel[key]){
          let optionIndex = formQuestion.data.findIndex(option => option.text == response)
          if (optionIndex != -1){
            points += formQuestion.data[optionIndex].value;
          }
        }
      }else if (formQuestion.type == "number"){
        if (this.formModel[key] == formQuestion.correctValue){
          points += formQuestion.value;
        }
      }
      
      questionIndex++;
    }
    return points;

  }

  startForm(){
    var testData = this.testService.selectedTestData;
    this.testService.testStarted = true;
    testData.isStarted = true;
    testData.startDate = Date.now();
    this.testService.updateTest(testData).subscribe();
    this.timer = setInterval(() => {
      this.countdown--;
      if (this.countdown <= 0){
        clearInterval(this.timer);
        location.reload()
      }
      if (this.countdown == 120){
        Swal.fire({
          position: 'top-end',
          icon: 'warning',
          text: 'Quedan 2 minutos para que el formulario se cierre automáticamente',
          showConfirmButton: false,
          timer: 3000
        })
      }
    }, 1000)
  }

  
}
